import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
import { Button } from '@design-system';

interface RateActionPageHeaderProps {
  clientId: string;
  title: string;
  subtitle?: string;
  /** Optional right-side controls rendered next to the close button. */
  actions?: React.ReactNode;
}

export function RateActionPageHeader({
  clientId,
  title,
  subtitle,
  actions,
}: RateActionPageHeaderProps) {
  const navigate = useNavigate();
  return (
    <div className="border-border bg-background sticky top-0 z-40 shrink-0 border-b px-4">
      <div className="mx-auto w-full max-w-5xl">
        <div className="flex items-start justify-between py-4">
          <div className="text-left">
            <h1 className="text-primary-dark flex items-center gap-2 text-lg font-semibold md:text-xl">
              {title}
            </h1>
            {subtitle && <p className="text-foreground text-sm md:text-base">{subtitle}</p>}
          </div>
          <div className="flex items-center gap-2">
            {actions}
            <Button
              variant="outline"
              size="icon-sm"
              aria-label="Close"
              className="rounded-full"
              disabled={!clientId}
              onClick={() => {
                if (clientId) navigate(`/clients/${clientId}/onboarding/funding-sources`);
              }}
            >
              <X />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
